import React from 'react'

const QualityOfCare = (props) => {
    let { widgetsPreviewData: Data } = props;
    let qualityOfCareData = Data?.QualityOfCare;
  return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='bg_yellow p-2 w-100'>
        <p className='heading font-b fs-13 mb-1 leter-spacing'>Quality of Care</p>
        <div className="ar_content">
            <div className="d-flex gap-40 align-items-center">

            <div className="d-flex flex-column gap-2">

                <div className="d-flex align-items-center gap-6">

                {qualityOfCareData?.SummaryOfCareSent === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Summary of care sent</p>
                </div>
                <div className="d-flex align-items-center gap-6">

                {qualityOfCareData?.IncomingTransferOfPatient === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Incoming transfer of care</p>
                </div>

                <div className="d-flex align-items-center gap-6">

                {qualityOfCareData?.OutgoingTransferOfCare === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Outgoing transfer of care</p>
                </div>
            </div>
            <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-center gap-6">
                {qualityOfCareData?.EducationMaterialGiven === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Education material given</p>
                </div>
                <div className="d-flex align-items-center gap-6">
                {qualityOfCareData?.PatientDeclinedSummary === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Patient declined summary</p>
                </div>
                <div className="d-flex align-items-center gap-6">
                {qualityOfCareData?.VirtualVisit === "true" ?
                    <i className="icon-check fs-15 fw-900"></i>
                    :
                    <i class="icon-alert fs-11"></i>}
                <p className="text fs-12">Virtual visit</p>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default QualityOfCare